import { Injectable, ViewChildren, QueryList } from '@angular/core';
import { IonRouterOutlet, ActionSheetController, PopoverController, LoadingController,
  ModalController, AlertController, MenuController, ToastController, PickerController } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})
export class CloseOverlayService {
  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;

  constructor(
    private actionSheet: ActionSheetController,
    private popover: PopoverController,
    private loading: LoadingController,
    private picker: PickerController,
    private toast: ToastController,
    private alert: AlertController,
    private modal: ModalController,
    private menu: MenuController
  ) { }
  async trigger() {
    console.log('Back button triggered');
    // close action sheet
    try {
      const element = await this.actionSheet.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
    }

    // close popover
    try {
      const element = await this.popover.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
    }

    // close loading
    try {
      const element = await this.loading.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
    }

    // close picker
    try {
      const element = await this.picker.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
    }

    // close toast
    try {
      const element = await this.toast.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
    }

    // close alert
    try {
      const element = await this.alert.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
    }

    // close modal
    try {
      const element = await this.modal.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
      console.log(error);

    }

    // close side menu
    try {
      const element = await this.menu.getOpen();
      if (element !== null) {
        this.menu.close();
        return;
      }
    } catch (error) {
    }
  }
}
